import { render, staticRenderFns } from "./ProductReviewSection.vue?vue&type=template&id=64bfe28e&scoped=true"
import script from "./ProductReviewSection.vue?vue&type=script&lang=js"
export * from "./ProductReviewSection.vue?vue&type=script&lang=js"
import style0 from "./ProductReviewSection.vue?vue&type=style&index=0&id=64bfe28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bfe28e",
  null
  
)

export default component.exports